import { useStore } from 'vuex';

export default function useLinkLinesToBeSaved()
{
    const store = useStore();

    /**
     * Assign a dependency code to all the lines in the "addToBasket" context,
     * provided there are more than one.
     */
    class LinkLinesToBeSaved
    {
        async handle()
        {
            const toBeSaved = store.state.basket.addToBasketContext.basketLines;

            // Do not set a dependency code if there's only one item with a quantity of 1
            if(toBeSaved.length === 1 && toBeSaved[0].quantity == 1)
            {
                console.log('Not setting a dependency code, because there is only one item to be saved, with a quantity of 1');
                return true;
            }

            return await store.dispatch('basket/linkPreparedLines');
        }
    }

    return LinkLinesToBeSaved;
}
